<div *ngIf="position==='right'" class="nearby-places-title">
    <mat-icon>room</mat-icon>
    NEARBY PLACES TO EXPLORE
</div>

<div *ngIf="position==='bottom'" class="flex nearby-title-row">
    <p>NEARBY PLACES TO EXPLORE</p>

    <div *ngIf="showingCount" class="showing-result"
         [ngClass]="{'result-height':showingCount}">
        <button tabindex="0" [ngClass]="{'no-more':noMoreBack}" (click)="pagingBack()" role="button"
                aria-label="go back">
            <mat-icon>chevron_left</mat-icon>
        </button>
        Showing {{showingCount}}
        <button tabindex="0" [ngClass]="{'no-more':noMoreNext}" (click)="pagingNext()" role="button"
                aria-label="go to next">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
</div>

<div *ngIf="isLoadingAllPlaces" class="relative">
    <ig-spinner></ig-spinner>
</div>
<div *ngIf="!isLoadingAllPlaces" class="nearby-img-wrap" [class.flex]="position==='bottom'" [class.right-style]="position==='right'">
    <div *ngFor="let item of nearByPlaces" (click)="gotoPlace(item)" [class.bottom-nearby]="position==='bottom'">
        <ig-visitor-long-card [item]="item" [preventClick]="true"></ig-visitor-long-card>
    </div>
</div>

<ng-container *ngIf="position==='right'">
    <div *ngIf="!isLoadingAllPlaces" class="showing-result" style="float: right"
         [ngClass]="{'result-height':showingCount}">
        <button tabindex="0" [ngClass]="{'no-more':noMoreBack}" (click)="pagingBack()" role="button" aria-label="go back">
            <mat-icon>chevron_left</mat-icon>
        </button>
        Showing {{showingCount}}
        <button tabindex="0" [ngClass]="{'no-more':noMoreNext}" (click)="pagingNext()" role="button"
                aria-label="go to next">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
</ng-container>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details.modal/nearby.places.component/nearby.places.component.html